<template>
  <div class="page_content">
    <template v-if="component_loading">
      <div class="component_loader">
        <spinner :status="component_loading" />
      </div>
    </template>
    <template>
      <div v-if="company_monthly_generated_salary_list.total > 0">
        <div
          v-for="generated_salary_item in company_monthly_generated_salary_list.data"
          :key="generated_salary_item.monthly_salary_id"
        >
          <div class="boxi m-t-20">
            <div class="row">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-2">
                    <template
                      v-if="
                        generated_salary_item.image_url == '' ||
                        generated_salary_item.image_url == null ||
                        generated_salary_item.image_url == undefined
                      "
                    >
                      <img
                        src="/images/user/no-image.png"
                        class="imgCandidate"
                      />
                    </template>
                    <template v-else>
                      <img
                        :src="
                          SERVER_URL +
                          IMAGES_FILES +
                          generated_salary_item.image_url
                        "
                        class="imgCandidate"
                      />
                    </template>
                  </div>
                  <div class="col-10">
                    <div class="textinBoxCandidateDetails">
                      <h4>
                        {{ generated_salary_item.name }}
                        {{ generated_salary_item.surname }}
                      </h4>
                      <h5>{{ generated_salary_item.position }}</h5>
                      <h5>{{ generated_salary_item.department }}</h5>
                      <p class="mb-0 text-muted">
                        {{ $t('employee_module.paymentcurrency') }}:
                        {{ getSourceCurrencyLabel(generated_salary_item) }}
                      </p>
                      <p class="mb-0 text-muted">
                        {{ $t('payroll_currency.shown_in') }}:
                        {{ getDisplayedCurrencyCode(generated_salary_item) }}
                      </p>
                      <p
                        v-if="isCurrencyConverted(generated_salary_item)"
                        class="mb-0 text-muted"
                      >
                        {{ $t('payroll_currency.conversion_rate') }}:
                        {{ formatConversionRate(generated_salary_item) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-4">
                    <div class="wages_list_details text-center">
                      <p>{{ $t('wages_module.salaryfor') }}</p>
                      <h4>
                        {{ $t('monthsvalue.' + generated_salary_item.month) }}
                        {{ generated_salary_item.year }}
                      </h4>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="wages_list_details text-center">
                      <p>{{ $t('wages_module.grosssalary') }}</p>
                      <h4>
                        {{
                          formatPayrollAmount(
                            generated_salary_item.gross_salary,
                            generated_salary_item
                          )
                        }}
                        {{ getDisplayedCurrencyCode(generated_salary_item) }}
                      </h4>
                    </div>
                    <div class="wages_list_details text-center">
                      <p>{{ $t('wages_module.grosssalarybonus') }}</p>
                      <h4>
                        {{
                          formatPayrollAmount(
                            generated_salary_item.bonus_payment,
                            generated_salary_item
                          )
                        }}
                        {{ getDisplayedCurrencyCode(generated_salary_item) }}
                      </h4>
                    </div>
                    <div class="wages_list_details text-center">
                      <p>{{ $t('wages_module.grosssalarytotal') }}</p>
                      <h4>
                        {{
                          formatPayrollAmount(
                            Number(generated_salary_item.gross_salary) +
                              Number(generated_salary_item.bonus_payment),
                            generated_salary_item
                          )
                        }}
                        {{ getDisplayedCurrencyCode(generated_salary_item) }}
                      </h4>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="wages_list_details text-center">
                      <p v-if="supportsSecondJob">
                        {{ $t('wages_module.rankofjob') }}
                      </p>
                      <h4
                        v-if="
                          supportsSecondJob &&
                          generated_salary_item.is_second_job == 0
                        "
                      >
                        {{ $t('salary_page.primaryjob') }}
                      </h4>
                      <h4
                        v-if="
                          supportsSecondJob &&
                          generated_salary_item.is_second_job == 1
                        "
                      >
                        {{ $t('salary_page.secondaryjob') }}
                      </h4>
                      <h4 v-if="!supportsSecondJob">-</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <div class="row">
              <div
                v-if="showPayrollField('tax_80_to_250_4_percent')"
                class="col-md-2"
              >
                <div class="wages_list_details text-center">
                  <p>{{ getPayrollLabel('tax_80_to_250_4_percent') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.tax_80_to_250_4_percent,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
              <div
                v-if="showPayrollField('tax_250_to_450_8_percent')"
                class="col-md-2"
              >
                <div class="wages_list_details text-center">
                  <p>{{ getPayrollLabel('tax_250_to_450_8_percent') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.tax_250_to_450_8_percent,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
              <div
                v-if="showPayrollField('tax_greater_450_10_percent')"
                class="col-md-2"
              >
                <div class="wages_list_details text-center">
                  <p>{{ getPayrollLabel('tax_greater_450_10_percent') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.tax_greater_450_10_percent,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
              <div class="col-md-2">
                <div class="wages_list_details text-center">
                  <p>{{ getPayrollLabel('contribution_5_percent') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.contribution_5_percent,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
              <div class="col-md-2">
                <div class="wages_list_details text-center">
                  <p>{{ $t('wages_module.totaltax') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.total_tax,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
              <div class="col-md-2">
                <div class="wages_list_details text-center">
                  <p>{{ $t('wages_module.netsalary') }}</p>
                  <h4 class="f-w">
                    {{
                      formatPayrollAmount(
                        generated_salary_item.net_salary,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-3">
                <div class="wages_list_details text-center">
                  <p>{{ $t('wages_module.advancepayment') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.advance_payment,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
              <div class="col-md-3">
                <div class="wages_list_details text-center">
                  <p>{{ $t('wages_module.leavewithoutpayment') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.leave_without_payment,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
              <div class="col-md-3">
                <div class="wages_list_details text-center">
                  <p>{{ $t('wages_module.bonuspayment') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.bonus_payment,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
              <div class="col-md-3">
                <div class="wages_list_details text-center">
                  <p>{{ $t('wages_module.mealspayment') }}</p>
                  <h4>
                    {{
                      formatPayrollAmount(
                        generated_salary_item.meals_payment,
                        generated_salary_item
                      )
                    }}
                    {{ getDisplayedCurrencyCode(generated_salary_item) }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-pagination
          v-if="
            company_monthly_generated_salary_list.total >
            company_monthly_generated_salary_list.per_page
          "
          align="center"
          class="m-t-20"
          @change="loadAnotherPage"
          :total-rows="company_monthly_generated_salary_list.total"
          v-model="company_monthly_generated_salary_list.current_page"
          :per-page="company_monthly_generated_salary_list.per_page"
        />
      </div>
      <div v-else>
        <div class="boxi m-t-20">
          <div class="textinBox">
            <h4 class="text-center">
              {{ $t('wages_module.nowagesgenerated') }}
            </h4>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  formatPayrollAmount as formatCurrencyAwarePayrollAmount,
  formatCurrencySuffix,
  getCurrencyOption,
  getPayrollFieldLabel,
  isSecondJobSupported,
  normalizeCountryCode,
  shouldShowPayrollField
} from '@/helpers/payrollCountry'
export default {
  computed: {
    company_monthly_generated_salary_list: function () {
      if (this.$store.getters['employee_data/finances/get']) {
        return this.$store.getters['employee_data/finances/get']
      }
    },
    companyProfileData() {
      return this.$store.getters['company_data/get'] || {}
    },
    companyCountry() {
      return normalizeCountryCode(this.companyProfileData.country_value)
    },
    companyPayrollCurrencyCode() {
      return (
        this.companyProfileData.main_currency ||
        formatCurrencySuffix(this.companyCountry)
      )
    },
    payrollCurrencySuffix() {
      return formatCurrencySuffix(this.companyCountry)
    },
    supportsSecondJob() {
      return isSecondJobSupported(this.companyCountry)
    }
  },

  watch: {
    company_monthly_generated_salary_list: function (new_value) {
      return new_value
    }
  },

  data() {
    return {
      component_loading: false
    }
  },

  methods: {
    getPayrollLabel(fieldKey) {
      return getPayrollFieldLabel(this.companyCountry, fieldKey)
    },
    showPayrollField(fieldKey) {
      return shouldShowPayrollField(this.companyCountry, fieldKey)
    },
    getDisplayedCurrencyCode(salaryItem) {
      return salaryItem.company_currency || this.companyPayrollCurrencyCode
    },
    getSourceCurrencyLabel(salaryItem) {
      return getCurrencyOption(salaryItem && salaryItem.payment_currency).label
    },
    isCurrencyConverted(salaryItem) {
      return Boolean(salaryItem && salaryItem.is_currency_converted)
    },
    formatConversionRate(salaryItem) {
      const conversionRate = Number(salaryItem && salaryItem.conversion_rate)
      return Number.isFinite(conversionRate)
        ? conversionRate.toFixed(4)
        : salaryItem.conversion_rate
    },
    formatPayrollAmount(value, salaryItem = null) {
      const currencyCode = salaryItem
        ? this.getDisplayedCurrencyCode(salaryItem)
        : this.companyPayrollCurrencyCode

      return formatCurrencyAwarePayrollAmount(value, currencyCode)
    },

    loadAnotherPage: function (page_number_to) {
      this.component_loading = true
      let data = {
        company_id: localStorage.getItem('employee_company_id'),
        employee_id: localStorage.getItem('employee_id'),
        page_number: page_number_to
      }
      setTimeout(() => {
        this.$store
          .dispatch(
            'employee_data/finances/get_salary_generations_with_page',
            data
          )
          .then(() => {
            this.component_loading = false
          })
      }, 200)
    }
  },

  created() {
    this.component_loading = true
    this.$store.dispatch('company_data/get_company_profile_data')

    let data = {
      company_id: localStorage.getItem('employee_company_id'),
      employee_id: localStorage.getItem('auth.user_id')
    }

    setTimeout(() => {
      this.$store
        .dispatch('employee_data/finances/get_salary_generations', data)
        .then(() => {
          this.component_loading = false
        })
    }, 200)
  }
}
</script>
